export default __webpack_public_path__ + "static/media/CEX.928834ca.png";